import { useMemo } from 'react';
import { useMediaQuery } from 'react-responsive';

import { SlideColorBubbleType } from 'components/Common/SlideColorBubbles/SlideColorBubbles';
import { formatColors } from 'services/slideColorBubbles';
import {
  MOBILE,
  MOBILE_AND_TABLET,
  TABLET_PORTRAIT,
  XS_MOBILE,
} from 'settings/mediaQuery';
import { ProductColorsType } from 'types/ProductPageV2/Products';

const useProductColors = (
  colors: ProductColorsType[],
  color?: string,
  editUrl?: string
): {
  slideColors: SlideColorBubbleType[];
  selectedColor: ProductColorsType | null;
  selectedColorIndex: number;
  useSlide: boolean;
} => {
  const COLORS_LAPTOP = 4;
  const COLORS_MOBILE_AND_TABLET = 4;
  const COLORS_TABLET_PORTRAIT = 8;
  const COLORS_MOBILE = 5;
  const COLORS_XS_MOBILE = 3;

  const isMobileAndTablet = useMediaQuery({
    query: MOBILE_AND_TABLET,
  });
  const isPortraitTablet = useMediaQuery({
    query: TABLET_PORTRAIT,
  });
  const isMobile = useMediaQuery({
    query: MOBILE,
  });
  const isXSMobile = useMediaQuery({
    query: XS_MOBILE,
  });
  const slideColors = useMemo(() => formatColors(colors, editUrl), [colors]);
  const selectedColorIndex = colors.findIndex(
    (c: ProductColorsType) => color === c.couleur
  );
  const selectedColor =
    selectedColorIndex !== -1 ? colors[selectedColorIndex] : null;

  const colorsByMedia = (): number => {
    switch (true) {
      case isXSMobile:
        return COLORS_XS_MOBILE;
      case isMobile:
        return COLORS_MOBILE;
      case isPortraitTablet:
        return COLORS_TABLET_PORTRAIT;
      case isMobileAndTablet:
        return COLORS_MOBILE_AND_TABLET;
    }

    return COLORS_LAPTOP;
  };

  return {
    slideColors,
    selectedColor,
    selectedColorIndex,
    useSlide:
      (isXSMobile || isMobile || isPortraitTablet) &&
      colors.length > colorsByMedia(),
  };
};

export default useProductColors;
